module.exports = __webpack_public_path__ + "static/img/you_video_pic4.2.74eae3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/scene/you_video_pic4.2.jpg
// module id = /I6i
// module chunks = 0